import { render, staticRenderFns } from "./MortgageAffordability.vue?vue&type=template&id=522f12f7"
import script from "./MortgageAffordability.vue?vue&type=script&lang=js"
export * from "./MortgageAffordability.vue?vue&type=script&lang=js"
import style0 from "./MortgageAffordability.vue?vue&type=style&index=0&id=522f12f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports